<template>
  <!-- Mirrors Event.vue's row on its own classes. The zero-width spaces give each bar one line of its element's text. -->
  <div class="event-row tw-pointer-events-none">
    <div class="event-row__time">
      <span class="event-row__start tw-flex tw-items-center">&#8203;<b-skeleton width="38px" height="0.8em" class="tw-mb-0"/></span>
      <span class="event-row__end tw-flex tw-items-center">&#8203;<b-skeleton width="30px" height="0.8em" class="tw-mb-0"/></span>
    </div>
    <div class="event-row__body">
      <div :class="isHome ? 'event-row__title' : 'event-row__date'" class="tw-flex tw-items-center">&#8203;<b-skeleton
          :width="width" height="0.8em" class="tw-mb-0"
      /></div>
    </div>
    <slot name="append"/>
  </div>
</template>

<script>
export default {
  props: {
    // Home rows show the title, the others the date.
    isHome: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '55%'
    }
  }
}
</script>
